import {BettingAdRepository} from "./betting-ad.repository";
import {BettingAdFactory} from "./betting-ad.factory";
import {BaseManagedService} from "../../../infrastructure/domain-services/base-managed-service";
import {DomainRequestManager} from "../../../core/managers/domain-request-manager";
import {BaseDomainService} from "../../../infrastructure/domain-services/base-domain-service";

export class BettingAdDomainService extends BaseDomainService {
  static injectables = [...BaseManagedService.injectables, BettingAdRepository, BettingAdFactory, DomainRequestManager];
}


